module.exports = __webpack_public_path__ + "img/20200508_173500.49f47015.jpg";